// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".l-title b[data-v-e2542e74]:after{content:\"\";width:100px;height:3px;background:#1f1bc0;position:absolute;left:50%;transform:translate(-50%);bottom:0}.list .warp p[data-v-e2542e74]{text-align:left}", ""]);
// Exports
module.exports = exports;
